// Content-type strings that drive the conditional distribution fields. These must
// match the backend `InfoHubSubject.CONTENT_TYPE_CHOICES` values exactly.
export const INPUT_DISTRIBUTION = "Input Distribution";
export const EQUIPMENT_DISTRIBUTION = "Equipment Distribution";

// Content types whose aggregator picker offers "Select all".
export const AGGREGATOR_INFORMATION = "Aggregator Information";
export const FARMER_TRAINING = "Farmer Training";

// Option definition: `value` is the backend choice code, `labelKey` is an i18n key.
export interface DistributionOptionDef {
  value: string;
  labelKey: string;
}

// Input distribution categories — mirrors choices.InputDistributionCategory.
export const INPUT_CATEGORY_OPTIONS: DistributionOptionDef[] = [
  { value: "SEEDS", labelKey: "infoHub.form.categorySeeds" },
  { value: "FERTILIZER", labelKey: "infoHub.form.categoryFertilizer" },
  { value: "CROP_PROTECTION", labelKey: "infoHub.form.categoryCropProtection" },
  { value: "OTHER_INPUTS", labelKey: "infoHub.form.categoryOtherInputs" },
];

// Equipment distribution types — mirrors choices.EquipmentDistributionType.
export const EQUIPMENT_TYPE_OPTIONS: DistributionOptionDef[] = [
  { value: "FARM_TOOLS", labelKey: "infoHub.form.equipmentFarmTools" },
  { value: "IRRIGATION_EQUIPMENT", labelKey: "infoHub.form.equipmentIrrigation" },
  { value: "MACHINERY", labelKey: "infoHub.form.equipmentMachinery" },
  { value: "POST_HARVEST_EQUIPMENT", labelKey: "infoHub.form.equipmentPostHarvest" },
  { value: "OTHER_EQUIPMENT", labelKey: "infoHub.form.equipmentOther" },
];
